import React from 'react';
import { useAccountContext } from '../Data/accountContext';
import FormBase from '../FormBase';
import TextField from '../../../../components/Textfields/TextField';
import RadioButtonGroup from '../../../../components/Buttons/RadioButtonGroup';
import Text from '../../../../components/Typography/Text';
import { associationMessage } from '../../../../lib/data/message';
import MessageModal from '../../../../components/Modals/MessageModal';
import FileAttachments from '../../../../components/Misc/FileAttachments';
import { hasError, validateAssociation } from '../Data/validation';
import { saveRegistrationAssociation } from '../../../../services/RegistrationService';
import { attachFiles } from '../../../../services/CommonService';

export default function FormAssociation() {
  const { account, setAccount, setAccountResponse, disableUpdate } = useAccountContext();
  const [openAttentionModal, setOpenAttentionModal] = React.useState(false);
  const [attachments, setAttachments] = React.useState([]);
  const [validation, setValidation] = React.useState({});

  const handleAttachFile = async (e) => {
    if (e.target.files.length === 0) {
      return;
    }

    setAttachments(e.target.files);
  };

  const handleChange = (e) => {
    const copy = { ...account };

    const input = e.currentTarget.name ? e.currentTarget : e.target;
    copy.primaryOwner.association = copy.primaryOwner.association || {};
    copy.primaryOwner.association[input.name] = input.value;
    setAccount({ ...copy });
  };

  const handleSave = async () => {
    const request = { ...account.primaryOwner.association };

    let errs = validateAssociation(request, attachments);

    setValidation(errs);

    if (hasError(errs)) {
      console.log('association errs', errs);
      return { acct: account, err: true };
    }

    // convert to bool
    request.brokerMember = request.brokerMember === 'Yes';
    request.ownership = request.ownership === 'Yes';

    if (attachments.length) {
      await attachFiles(
        account.accountId,
        'ClientAccount',
        attachments,
        'employer-authorization'
      );
    }

    const res = await saveRegistrationAssociation(request);
    const copy = { ...account };
    copy.primaryOwner.association = res;
    setAccountResponse(copy);
    setAttachments([]);

    return { acct: copy, err: false };
  };

  const data = account.primaryOwner.association || {
    ownership: 'No',
    brokerMember: 'No',
  };

  return (
    <FormBase
      name="association"
      header="Investor Association"
      subHeader=""
      faq="Association"
      save={handleSave}
    >
      <form className="association-form-w" autoComplete="off">
        <input type="hidden" autoComplete="off" />
        <RadioButtonGroup
          name="ownership"
          label="Are you or a family member a senior executive or 10% or greater
                                shareholder of a publicly traded company?"
          value={data.ownership}
          options={['Yes', 'No']}
          onChange={handleChange}
          disabled={disableUpdate}
        />
        {data.ownership === 'Yes' && (
          <TextField
            required={true}
            error={!!validation.stockOwnership}
            msg={validation.stockOwnership}
            mt={20}
            max={50}
            name="stockOwnership"
            label="Stock Symbol"
            placeholder="Stock Symbol"
            type="text"
            value={data.stockOwnership}
            onChange={handleChange}
            disabled={disableUpdate}
          />
        )}
        <RadioButtonGroup
          mt={30}
          name="brokerMember"
          label="Are you or a family member employed with a member firm of a
                                stock exchange or Finra registered broker?"
          value={data.brokerMember}
          options={['Yes', 'No']}
          onChange={handleChange}
          disabled={disableUpdate}
        />
        {data.brokerMember === 'Yes' && (
          <div>
            <TextField
              required={true}
              error={!!validation.brokerName}
              msg={validation.brokerName}
              mt={20}
              max={50}
              name="brokerName"
              label="Name of the Company"
              placeholder="Name of the Company"
              type="text"
              value={data.brokerName}
              onChange={handleChange}
              disabled={disableUpdate}
            />
            <TextField
              required={true}
              error={!!validation.affiliatePerson}
              msg={validation.affiliatePerson}
              mt={20}
              max={50}
              name="affiliatePerson"
              label="Name of the Affiliated Person"
              placeholder="Name of the Affiliated Person"
              type="text"
              value={data.affiliatePerson}
              onChange={handleChange}
              disabled={disableUpdate}
            />
            <TextField
              required={true}
              error={!!validation.affiliatePersonPosition}
              msg={validation.affiliatePersonPosition}
              mt={20}
              max={50}
              name="affiliatePersonPosition"
              label="Postion of the Affiliated Person"
              placeholder="Postion of the Affiliated Person"
              type="text"
              value={data.affiliatePersonPosition}
              onChange={handleChange}
              disabled={disableUpdate}
            />
            <FileAttachments
              required={true}
              error={!!validation.attachments}
              msg={validation.attachments}
              title="Please attach your account authorization from your employer"
              attachments={attachments}
              onChange={handleAttachFile}
              setAttachments={setAttachments}
              disabled={disableUpdate}
            />

            <div>
              <Text mt={20} mb={10} mr={5} variant="subtitle1" label="Attached Files" />
              <ul>
                {data?.attachedFilesList?.map((fileName, index) => (
                  <li key={index}>{fileName}</li>
                ))}
              </ul>
            </div>
          </div>
        )}
        <MessageModal
          modalTitle="Attention"
          content={associationMessage}
          open={openAttentionModal}
          onClose={() => {
            setOpenAttentionModal(false);
          }}
          disabled={disableUpdate}
        />
      </form>
    </FormBase>
  );
}
